<app-tabla
  [totalCount]="totalCount"
  [datos]="alertasBotonesBLE"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [filtros]="filtros"
  [emptyState]="{ title: 'Todavía no hay alertas de botones BLE' }"
></app-tabla>
